import { z } from 'zod/v4';
import { PerformedBySchema } from '../../performed-by/index.js';
import { TribunalCaseStatus } from '../../tribunal/cases/types.js';
import { TribunalJobType } from '../../tribunal/jobs/types.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    tribunalCaseId: z
        .uuid()
        .describe('The tribunal case to fetch. Obtain via search_tribunal_cases — do not invent ids.'),
});
const outputSchema = z.object({
    tribunalCaseId: z.uuid(),
    type: z.string(),
    status: z.enum(TribunalCaseStatus),
    reference: z.string().nullable(),
    country: z.string(),
    createdAt: z.iso.datetime(),
    createdBy: PerformedBySchema.nullable(),
    events: z.array(z.object({
        type: z.enum(TribunalJobType),
        createdAt: z.iso.datetime(),
        createdBy: PerformedBySchema.nullable(),
    })),
});
export const getTribunalCaseTool = {
    name: ToolName.GetTribunalCase,
    category: ToolCategory.Tribunal,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Read full details of a tribunal case: type, status, country, and the chronological events log.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-tribunal-case.js.map